export const ru = {
  common: {
    back: 'Назад',
    close: 'Закрыть',
    cancel: 'Отмена',
    save: 'Сохранить',
    copy: 'Копировать',
    copied: 'Скопировано',
    search: 'Поиск',
    loading: 'Загрузка…',
    dismiss: 'Скрыть',
    members: 'Участники',
    owner: 'Владелец',
    online: 'В сети',
    offline: 'Не в сети',
    idle: 'Отошёл',
    dnd: 'Не беспокоить',
    invisible: 'Невидимый',
    unknown: 'неизвестно',
    language: 'Язык',
    russian: 'Русский',
    english: 'English',
    error: 'Что-то пошло не так',
    you: '(вы)',
    closeMemberList: 'Закрыть список участников',
    total: '{count} всего',
    create: 'Создать',
    join: 'Войти',
    add: 'Добавить',
    revoke: 'Отменить',
    description: 'Описание',
    muteNotifications: 'Отключить уведомления',
    unmuteNotifications: 'Включить уведомления',
  },
  boot: {
    connecting: 'Подключение к TetherChat…',
  },
  auth: {
    loginTitle: 'С возвращением',
    loginSubtitle: 'Рады видеть вас снова.',
    loginIdentifier: 'Email или имя пользователя',
    password: 'Пароль',
    forgotPassword: 'Забыли пароль?',
    logIn: 'Войти',
    needAccount: 'Нет аккаунта?',
    register: 'Регистрация',
    loginFailed: 'Не удалось войти',
    totpTitle: 'Двухфакторка',
    totpSubtitle: 'Введите код из приложения-аутентификатора.',
    totpContinue: 'Продолжить',
    banned: 'Аккаунт заблокирован',
    passwordTab: 'Пароль',
    qrTab: 'QR-код',
    qrTitle: 'Вход по QR-коду',
    qrSubtitle: 'Отсканируйте код в мобильном приложении TetherChat.',
    qrHint: 'На телефоне: Настройки → Сессии → Сканировать QR для входа на компьютере.',
    qrWaiting: 'Ждём подтверждения на телефоне…',
    qrRefresh: 'Обновить код',
    qrRetry: 'Попробовать снова',
    qrExpired: 'Код устарел. Нажмите «Обновить код».',
    qrAlt: 'QR-код для входа',
    qrStartFailed: 'Не удалось создать QR-код',
    qrPollFailed: 'Не удалось проверить статус входа',
    registerTitle: 'Создать аккаунт',
    alreadyRegistered: 'Уже есть аккаунт?',
    email: 'Email',
    username: 'Имя пользователя',
    displayName: 'Отображаемое имя',
    displayNameHint: 'Необязательно. Показывается вместо имени пользователя.',
    continue: 'Продолжить',
    registerFailed: 'Не удалось создать аккаунт',
    registerVerifyHint: 'После регистрации мы отправим письмо с ссылкой для подтверждения почты. Без этого восстановление пароля недоступно.',
    invalidEmail: 'Введите корректный email',
    usernameMin: 'Не меньше {min} символов',
    usernamePattern: 'Строчные буквы, цифры, точка, дефис и подчёркивание',
    passwordMin: 'Не меньше {min} символов',
    resetTitle: 'Сброс пароля',
    resetSent: 'Если этот адрес зарегистрирован и подтверждён, письмо уже в пути.',
    resetHint: 'Отправим одноразовую ссылку на подтверждённую почту. Сначала подтвердите email после регистрации.',
    backToLogin: 'Вернуться ко входу',
    sendReset: 'Отправить ссылку',
    newPasswordTitle: 'Новый пароль',
    newPassword: 'Новый пароль',
    updatePassword: 'Обновить пароль',
    passwordUpdated: 'Пароль обновлён — войдите с новым',
    missingToken: 'В ссылке нет токена.',
    verifyWorking: 'Проверяем…',
    verifyDone: 'Email подтверждён',
    verifyFailed: 'Не удалось подтвердить',
    resendVerification: 'Отправить письмо повторно',
    verificationSent: 'Письмо с подтверждением отправлено',
    verifyEmailHint: 'Подтвердите почту по ссылке из письма, чтобы восстановить пароль.',
    continueToApp: 'Перейти в TetherChat',
  },
  invite: {
    checking: 'Проверяем приглашение…',
    invalid: 'Недействительное приглашение',
    invalidHint: 'Срок истёк или ссылка не существует.',
    goToApp: 'Перейти в TetherChat',
    invited: '{name} приглашает вас · {count} участников',
    alreadyHaveAccount: 'Уже есть аккаунт?',
    openServer: 'Открыть сервер',
    accept: 'Принять приглашение',
    signUpToJoin: 'Зарегистрироваться, чтобы войти',
  },
  crash: {
    title: 'Что-то сломалось',
    body: 'TetherChat столкнулся с ошибкой. Обычно помогает перезагрузка.',
    reload: 'Перезагрузить',
    tryAgain: 'Попробовать снова',
  },
  update: {
    ready: 'Доступна новая версия TetherChat.',
    reload: 'Обновить',
    later: 'Позже',
  },
  connection: {
    lost: 'Связь потеряна — пробуем снова',
    reconnecting: 'Переподключение к TetherChat…',
  },
  palette: {
    open: 'Быстрый переход',
    placeholder: 'Перейти к каналу, диалогу или действию…',
    empty: 'Ничего не найдено',
    servers: 'Серверы',
    channels: 'Каналы',
    conversations: 'Диалоги',
    friends: 'Друзья',
    messages: 'Сообщения',
    actions: 'Действия',
    hintNavigate: 'навигация',
    hintSelect: 'открыть',
    hintClose: 'закрыть',
  },
  nav: {
    servers: 'Серверы',
    directMessages: 'Личные сообщения',
    addServer: 'Добавить сервер',
    joinServer: 'Присоединиться к серверу',
    joinInvite: 'Войти по приглашению',
    userSettings: 'Настройки пользователя',
    findConversation: 'Найти или начать беседу',
    newConversation: 'Новый диалог',
    leaveGroup: 'Покинуть группу',
    invitePeople: 'Пригласить людей',
    serverSettings: 'Настройки сервера',
    createChannel: 'Создать канал',
    leaveServer: 'Покинуть сервер',
    settings: 'Настройки',
  },
  chat: {
    back: 'Назад',
    notificationSettings: 'Настройки уведомлений',
    pinned: 'Закреплённые сообщения',
    hideMembers: 'Скрыть список участников',
    showMembers: 'Показать список участников',
    search: 'Поиск',
    attach: 'Прикрепить файл',
    emoji: 'Эмодзи',
    send: 'Отправить сообщение',
    cancelReply: 'Отменить ответ',
    replyTo: 'Ответ для',
    messageChannel: 'Написать #{name}',
    messageUser: 'Написать {name}',
    messageAi: 'Спросите нейросеть…',
    messageVpn: 'Напишите боту: тарифы, подписка, пробный…',
    messageMonitor: 'Проверка сервера: статус, диск, docker…',
    selectChannel: 'Выберите канал',
    noPermission: 'У вас нет права писать в этот канал',
    friendsOnly: 'Личные сообщения можно отправлять только друзьям',
    tooLong: 'Сообщение не длиннее {max} символов',
    fileTooBig: '{name} больше {size}',
    uploadFailed: 'Не удалось загрузить {name}',
    removeFile: 'Убрать {name}',
    jumpToPresent: 'К последним сообщениям',
    historyFar: 'Это сообщение дальше в истории',
    welcomeChannel: 'Добро пожаловать в #{name}!',
    startChannel: 'Это начало канала #{name}.',
    startDm: 'Это начало вашей переписки.',
    startAi: 'Это чат с нейросетью. Пишите как в обычном диалоге — ответы бесплатные.',
    startVpn: 'Это VPN-бот. Напишите **меню**, **тарифы**, **подписка** или **пробный**.',
    startMonitor: 'Бот мониторинга сервера. Напишите **статус**, **диск**, **docker** или **помощь**.',
    noChannel: 'Канал не выбран',
    pickChannel: 'Выберите канал в списке слева.',
    unread: 'Новое',
    edited: '(изменено)',
    sending: 'Отправка…',
    failed: 'Не отправлено',
    retrySend: 'Не доставлено · нажми, чтобы повторить',
    openThread: 'Тред',
    thread: 'Тред',
    threadReply: 'Ответ в треде…',
    threadReplies: '{count} в треде',
    seenBy: 'Видели {count}',
    select: 'Выбрать',
    selectedCount: 'Выбрано: {count}',
    forwardedMany: 'Переслано сообщений: {count}',
    searchEverywhere: 'Поиск везде',
    searchAll: 'Везде',
    searchHere: 'Здесь',
    searchMatchFile: 'файл',
    searchMatchLink: 'ссылка',
    originalDeleted: 'Исходное сообщение удалено',
    openProfile: 'Открыть профиль {name}',
    addReaction: 'Добавить реакцию',
    reply: 'Ответить',
    forward: 'Переслать',
    forwarded: 'Сообщение переслано',
    forwardTo: 'Переслать в…',
    forwardEmpty: 'Некуда переслать',
    forwardedFrom: 'Переслано от {name}',
    voice: 'Голосовое сообщение',
    recording: '{clock}',
    voiceFailed: 'Не удалось отправить голосовое',
    micDenied: 'Нет доступа к микрофону',
    voicePlay: 'Прослушать',
    voicePause: 'Пауза',
    voiceDelete: 'Удалить голосовое',
    voiceSend: 'Отправить голосовое',
    edit: 'Изменить',
    pin: 'Закрепить',
    unpin: 'Открепить',
    delete: 'Удалить',
    copyText: 'Копировать текст',
    editMessage: 'Изменить сообщение',
    pinMessage: 'Закрепить сообщение',
    unpinMessage: 'Открепить сообщение',
    deleteMessage: 'Удалить сообщение',
    moreReactions: 'Ещё реакции',
    reactWith: 'Реакция {emoji}',
    reactedWith: '{count} с реакцией {emoji}',
    copied: 'Сообщение скопировано',
    reactions: 'Реакции',
    closePicker: 'Закрыть выбор эмодзи',
    searchTitleDm: 'Поиск: {name}',
    searchTitleChannel: 'Поиск #{name}',
    searchMessages: 'Поиск сообщений…',
    searchHint: 'Введите хотя бы два символа.',
    searchEmpty: 'Ничего не найдено.',
    pinsTitle: 'Закреплённые сообщения',
    pinsDm: 'Закрепление доступно в каналах сервера.',
    pinsEmpty: 'Пока ничего не закреплено.',
    editorCancel: 'отмена',
    editorSave: 'сохранить',
    editorHint: 'escape — {cancel} · enter — {save}',
    everyone: '@everyone',
    chatSettings: 'Настройки чата',
    mediaTitle: 'Медиа чата',
    mediaEmpty: 'В этом чате пока нет фото и видео.',
    spoilerReveal: 'Нажмите, чтобы показать',
    nextMedia: 'Следующее',
    markSpoiler: 'Спойлер',
    pinChat: 'Закрепить',
    unpinChat: 'Открепить',
    deleteForMe: 'Удалить для себя',
    deleteForAll: 'Удалить для всех',
    deleteForMeConfirm: 'Удалить чат «{name}» только у вас? История сохранится у собеседника.',
    deleteForAllConfirm: 'Удалить чат «{name}» для всех? История будет удалена у обоих.',
    deleteGroupForAllConfirm: 'Удалить группу «{name}» для всех участников?',
  },
  call: {
    start: 'Позвонить',
    calling: 'Звоним…',
    incoming: 'Входящий звонок',
    connecting: 'Подключение…',
    active: 'Разговор',
    ended: 'Звонок завершён',
    accept: 'Принять',
    decline: 'Отклонить',
    hangUp: 'Завершить',
    mute: 'Выключить микрофон',
    unmute: 'Включить микрофон',
    enableSound: 'Включить звук',
    minimize: 'Свернуть звонок',
    expand: 'Вернуться к звонку',
    unknown: 'Контакт',
  },
  typing: {
    one: 'печатает…',
    many: 'печатают…',
    and: '{a} и {b}',
    three: '{a}, {b} и {c}',
    people: '{count} человек',
  },
  channel: {
    createIn: 'Создать канал в {name}',
    markRead: 'Отметить прочитанным',
    copyLink: 'Копировать ссылку',
    editChannel: 'Изменить канал',
    deleteChannel: 'Удалить канал',
    linkCopied: 'Ссылка на канал скопирована',
    createTitle: 'Создать текстовый канал',
    create: 'Создать канал',
    name: 'Название канала',
    namePlaceholder: 'новый-канал',
    topic: 'Тема',
    topicPlaceholder: 'О чём этот канал?',
    nameRequired: 'Дайте каналу имя',
    created: '#{name} создан',
    settingsName: 'Название канала',
    settingsTopic: 'Тема канала',
    settingsTopicHint: 'Пусть людям будет понятно, зачем канал.',
    muteChannel: 'Отключить уведомления канала',
    unmuteChannel: 'Включить уведомления канала',
    deleteConfirm: 'Удалить #{name} и все сообщения? Это действие нельзя отменить.',
    keepChannel: 'Оставить канал',
    channelUpdated: 'Канал обновлён',
    channelDeleted: 'Канал удалён',
  },
  server: {
    createTitle: 'Создать сервер',
    name: 'Название сервера',
    namePlaceholder: 'Friendos',
    createHint: 'Для вас сразу создадутся каналы #general и #off-topic.',
    joinTitle: 'Присоединиться к серверу',
    inviteLink: 'Ссылка-приглашение',
    membersCount: '{count} участников',
    options: 'Действия сервера',
    createDescription:
      'Ваш сервер — место для общения с друзьями. Создайте свой и начните разговор.',
    createReady: '{name} готов',
    joinDescription: 'Введите приглашение ниже, чтобы присоединиться к существующему серверу.',
    joinInvalid: 'Вставьте ссылку-приглашение или код',
    joined: 'Вы присоединились к серверу',
    nameMin: 'Не меньше {min} символов',
    settingsTitle: 'Настройки {name}',
    changeIcon: 'Сменить иконку',
    iconHint: 'PNG, JPEG, GIF или WebP. Размер до 128px.',
    serverUpdated: 'Сервер обновлён',
    deleteServerTitle: 'Удалить этот сервер',
    deleteServerHint:
      'Все каналы, сообщения и участники будут удалены. Введите {name} для подтверждения.',
    confirmServerName: 'Подтвердите название сервера',
    serverDeleted: 'Сервер удалён',
    overview: 'Обзор',
    roles: 'Роли',
    bans: 'Баны',
    settingsSections: 'Разделы настроек сервера',
    newRole: 'Новая роль',
    newRoleName: 'Название новой роли',
    roleName: 'Название роли',
    showSeparately: 'Показывать отдельно',
    showSeparatelyHint: 'Участники с этой ролью получают отдельный блок в списке.',
    permissions: 'Права',
    saveRole: 'Сохранить роль',
    roleSaved: 'Роль сохранена',
    roleDeleted: 'Роль удалена',
    kickMember: 'Исключить участника',
    banMember: 'Забанить участника',
    memberRemoved: 'Участник исключён',
    memberBanned: 'Участник забанен',
    nobodyBanned: 'Никого не забанено.',
    banLifted: 'Бан снят',
    deleteServerButton: 'Удалить сервер',
    deleteRole: 'Удалить роль',
  },
  dm: {
    title: 'Личные сообщения',
    findPeople: 'Найти людей',
    usernamePlaceholder: 'Введите имя пользователя',
    newConversation: 'Новый диалог',
    emptyHint: 'Пока нет бесед. Начните с кнопки + выше.',
    conversation: 'Беседа',
    savedMessages: 'Избранное',
    savedHint: 'Сохранённые сообщения',
    aiChat: 'Нейросеть',
    aiHint: 'Чат с нейросетью',
    vpnChat: 'Enigma VPN',
    vpnHint: 'VPN для Happ — тарифы и подписка',
    newConversationDescription: 'Только друзья. До {max} человек в группе.',
    createGroup: 'Создать группу',
    openConversation: 'Открыть беседу',
    nobodyMatched: 'Никого не найдено.',
    searchHintShort: 'Введите хотя бы два символа для поиска.',
  },
  friends: {
    title: 'Друзья',
    empty: 'В списке друзей пока никого нет.',
    sendRequest: 'Отправить заявку',
    sendRequestHint: 'Найдите человека по имени и отправьте заявку в друзья.',
    requestSent: 'Заявка отправлена',
    becameFriends: 'Теперь вы друзья',
    incomingTitle: 'Заявки в друзья',
    incoming: 'Заявки',
    emptyIncoming: 'Новых заявок нет.',
    accept: 'Принять',
    decline: 'Отклонить',
    add: 'Добавить в друзья',
  },
  report: {
    title: 'Пожаловаться',
    comment: 'Сообщение админу',
    commentPlaceholder: 'Что не так с этим сообщением?',
    submit: 'Отправить',
    sent: 'Жалоба отправлена',
  },
  admin: {
    loginData: 'Данные для входа',
    loginDataHint: 'Логин и пароль для приложения админ-панели. Новые каждый день, сгорают в 00:00 по Москве.',
    needsTwoFactor: 'Сначала включите двухфакторку.',
    showCredentials: 'Показать данные',
    expiresAt: 'Действуют до {time}',
  },
  settings: {
    title: 'Настройки пользователя',
    sections: 'Разделы настроек',
    profile: 'Мой профиль',
    account: 'Аккаунт',
    notifications: 'Уведомления',
    appearance: 'Оформление',
    logOut: 'Выйти',
    myAccount: 'Мой аккаунт',
    editProfile: 'Редактировать профиль',
    accountSecurity: 'Аккаунт и безопасность',
    appSettings: 'Приложение',
    theme: 'Тема',
    themeHint: 'TetherChat идёт с одной тёмной темой. Цвета заданы CSS-переменными.',
    dark: 'Тёмная',
    enterToSend: 'Enter отправляет сообщение',
    enterToSendMobile: 'На телефоне всегда видна кнопка отправки, а Enter делает новую строку.',
    enterToSendDesktop: 'Выключите, чтобы Enter делал новую строку, а отправка шла кнопкой.',
    languageHint: 'Язык интерфейса. По умолчанию — русский.',
    push: 'Push-уведомления',
    pushHint: 'Уведомления о сообщениях, даже когда TetherChat закрыт.',
    pushBanner: 'Включите уведомления, чтобы не пропускать сообщения.',
    pushBannerAction: 'Включить',
    pushUnsupported: ' Этот браузер не поддерживает push.',
    pushBlocked: 'Уведомления заблокированы в настройках браузера',
    pushUnsupportedToast: 'Этот браузер не умеет принимать push-уведомления',
    pushOn: 'Push-уведомления включены',
    pushOff: 'Push-уведомления выключены',
    pushSiteBlocked: 'Уведомления для этого сайта заблокированы. Разрешите их в браузере и попробуйте снова.',
    perChannel: 'Настройки каналов',
    perChannelHint: 'Отключить уведомления канала можно из его контекстного меню.',
    managedPerChannel: 'Настраивается у канала',
    email: 'Email',
    verified: 'Подтверждён',
    unverified: 'Не подтверждён',
    username: 'Имя пользователя',
    usernameHint: 'Строчные буквы, цифры, точка, дефис и подчёркивание.',
    usernameBad: 'Такое имя нельзя использовать',
    usernameUpdated: 'Имя обновлено',
    saveUsername: 'Сохранить имя',
    password: 'Пароль',
    passwordHint: 'Отправим одноразовую ссылку на {email}. После сброса все сессии завершатся.',
    passwordUnverifiedHint: 'Сначала подтвердите почту — без этого сброс пароля недоступен.',
    sendReset: 'Отправить ссылку сброса',
    resetSent: 'Ссылка сброса отправлена на почту',
    displayName: 'Отображаемое имя',
    displayHint: 'Показывается вместо имени пользователя. Оставьте пустым, чтобы использовать @username.',
    customStatus: 'Статус',
    customStatusPlaceholder: 'Чем занимаетесь?',
    about: 'О себе',
    aboutPlaceholder: 'Коротко о себе.',
    changeAvatar: 'Сменить аватар',
    remove: 'Убрать',
    saveChanges: 'Сохранить изменения',
    profileUpdated: 'Профиль обновлён',
    avatarUpdated: 'Аватар обновлён',
    downloadApp: 'Приложение для Android',
    downloadAppHint:
      'Поставьте нативное приложение TetherChat на телефон. Если обновление не ставится поверх старой версии, удалите приложение и установите APK заново.',
    downloadApk: 'Скачать APK',
    downloadAppInstalled: 'Приложение уже установлено',
    blockedUsers: 'Чёрный список',
    blockedUsersHint: 'Заблокированные не пишут вам в личные сообщения и не присылают уведомления.',
    blockedEmpty: 'Пока никого нет.',
    blockUser: 'Заблокировать',
    unblockUser: 'Разблокировать',
    userBlocked: 'Пользователь заблокирован',
    userUnblocked: 'Пользователь разблокирован',
    blockConfirm: 'Заблокировать {name}? Личные сообщения скроются, уведомления от него перестанут приходить.',
    sessions: 'Сессии',
    sessionsHint: 'Устройства, где выполнен вход. Завершите чужой сеанс, если это не вы.',
    thisDevice: 'Это устройство',
    lastActive: 'активен {time}',
    twoFactor: 'Двухфакторная аутентификация',
    twoFactorHint: 'При входе дополнительно спросим код из приложения-аутентификатора. Необязательно, но сильно безопаснее.',
    twoFactorEnable: 'Включить двухфакторку',
    twoFactorConfirm: 'Подтвердить и включить',
    twoFactorDisable: 'Выключить',
    twoFactorCode: 'Код из приложения',
    twoFactorOn: 'Двухфакторка включена',
    twoFactorOff: 'Двухфакторка выключена',
    twoFactorEnabled: 'Сейчас включена.',
    endSession: 'Завершить',
    endOtherSessions: 'Выйти на всех других устройствах',
    sessionRevoked: 'Сессия завершена',
    otherSessionsRevoked: 'Другие сессии завершены',
    plus: 'TetherChat Plus',
    aboutApp: 'О приложении',
    aboutAppHint: 'Версия, создатель, история изменений',
    creator: 'Создатель',
    versionHistory: 'История версий',
    versionHistoryHint: 'Что нового в каждом обновлении',
    currentVersion: 'Текущая версия',
    currentBadge: 'текущая',
    versionLabel: 'Версия {version}',
    whatsNew: 'Что нового',
    noReleaseNotes: 'Нет описания для этой версии.',
    requiresReinstall: 'Требовалась переустановка приложения',
    androidVersion: 'Android {version}',
    androidVersionUnknown: 'Версия Android загружается…',
    install: 'Установить',
    installHint: 'Скачайте нативное приложение TetherChat на телефон, Windows или Linux.',
    installUnavailable: 'Не удалось загрузить ссылки. Попробуйте позже.',
    installAndroid: 'Android (APK)',
    installAndroidHint: 'Установите на телефон. Если обновление не ставится — удалите старую версию и установите APK заново.',
    installWindows: 'Windows',
    installWindowsHint: 'Установщик .exe для Windows 10/11. Отдельная программа, не браузер.',
    installLinuxAppImage: 'Linux (AppImage)',
    installLinuxAppImageHint: 'Универсальный AppImage: chmod +x и запуск.',
    installLinuxDeb: 'Linux (deb)',
    installLinuxDebHint: 'Пакет для Ubuntu/Debian: sudo dpkg -i TetherChat.deb',
    downloadExe: 'Скачать .exe',
    downloadAppImage: 'Скачать AppImage',
    downloadDeb: 'Скачать .deb',
  },
  status: {
    online: 'В сети',
    idle: 'Отошёл',
    dnd: 'Не беспокоить',
    dndHint: 'Без уведомлений на рабочем столе',
    invisible: 'Невидимый',
    invisibleHint: 'Вы выглядите офлайн, но остаётесь в сети',
    logOut: 'Выйти',
  },
  inviteDialog: {
    title: 'Пригласить людей на {name}',
    description: 'Отправьте эту ссылку тем, кого хотите пригласить.',
    link: 'Ссылка-приглашение',
    copyFailed: 'Не скопировалось — выделите ссылку вручную',
    newLink: 'Создать новую ссылку',
    generated: 'Новое приглашение создано',
  },
  profile: {
    sendDm: 'Написать',
    addFriend: 'Добавить в друзья',
    requestSent: 'Заявка отправлена',
    memberSince: 'На TetherChat с',
    aboutMe: 'О себе',
    roles: 'Роли',
  },
  time: {
    todayAt: '[Сегодня в] HH:mm',
    yesterdayAt: '[Вчера в] HH:mm',
    today: 'Сегодня',
    yesterday: 'Вчера',
  },
  plus: {
    title: 'TetherChat Plus',
    badge: 'Plus',
    feature: 'Возможность',
    free: 'Бесплатно',
    paid: 'Plus',
    ctaHint: 'Напишите администратору, чтобы подключить Plus. Оплата появится позже.',
    activeHint: 'Подписка активна. Спасибо, что поддерживаете TetherChat.',
    writeAdmin: 'Чтобы подключить Plus, напишите администратору платформы.',
    openSettings: 'Открыть TetherChat Plus',
    upsellTitle: 'Это в Plus',
    upsellGeneric: 'Эта возможность доступна с TetherChat Plus.',
    upsellFiles: 'Файлы до 30 МБ — в Plus. На бесплатном тарифе лимит 10 МБ.',
    upsellPins: 'На бесплатном тарифе можно закрепить 5 чатов. Plus даёт 10.',
    upsellBio: 'Plus увеличивает «О себе» до 500 символов и делает ссылки кликабельными.',
    upsellTranscript: 'Расшифровка голосовых — кнопка на аудио в Plus.',
    upsellColors: 'Свой цвет баннера и имени — в Plus.',
    upsellLastSeen: 'Скрыть точное время захода можно только в Plus.',
    upsellWallpaper: 'Свой фон чата — в Plus.',
    upsellAccounts: 'Два аккаунта с быстрым переключением — в Plus.',
    upsellSecret: 'Защита экрана в секретном чате — в Plus. Скриншоты система не блокирует на 100%.',
    perkFiles: 'Файлы 30 МБ и без лимита аплоада',
    perkPins: '10 закреплённых чатов',
    perkTranscript: 'Расшифровка голосовых',
    perkBadge: 'Бейдж Plus и свои цвета',
    screenshotHint:
      'Защита секретного чата скрывает переписку в недавних приложениях и при сворачивании. Скриншот система не блокирует полностью — как в Telegram.',
    adminGrant: 'Выдача Plus',
    grantSelf: 'Включить Plus себе',
    revokeSelf: 'Выключить Plus себе',
    grantUsername: 'Имя пользователя',
    grant: 'Выдать',
    revoke: 'Забрать',
    granted: 'Plus включён',
    revoked: 'Plus выключен',
    userNotFound: 'Пользователь не найден',
    lastSeen: 'был(а) {time}',
    hideLastSeen: 'Скрывать время захода',
    hideLastSeenHint: 'Другие увидят только «в сети» или «не в сети».',
    bannerColor: 'Цвет баннера',
    accentColor: 'Цвет имени',
    colorsHint: 'Свои цвета профиля доступны в Plus.',
    chatHidden: 'Чат скрыт',
    peerProtect: 'У собеседника защита экрана',
    addAccount: 'Добавить аккаунт',
    switchAccount: 'Переключить аккаунт',
    accountsFull: 'Уже сохранены два аккаунта',
    transcribe: 'Расшифровать',
    transcribing: 'Расшифровка…',
    wallpaper: 'Фон чата',
    changeWallpaper: 'Сменить фон',
    removeWallpaper: 'Убрать фон',
    row: {
      files: 'Размер файла',
      pins: 'Закрепы ЛС и групп',
      bio: 'О себе, символов',
      accounts: 'Аккаунты',
      transcript: 'Транскрипт голосовых',
      upload: 'Лимит аплоада',
      lastSeen: '«Был(а) в сети»',
      secret: 'Секретный чат',
      colors: 'Цвета профиля',
      badge: 'Бейдж Plus',
      wallpaper: 'Фон чата',
      icons: 'Иконка Android',
    },
  },
} as const;

export const en = {
  common: {
    back: 'Back',
    close: 'Close',
    cancel: 'Cancel',
    save: 'Save',
    copy: 'Copy',
    copied: 'Copied',
    search: 'Search',
    loading: 'Loading…',
    dismiss: 'Dismiss',
    members: 'Members',
    owner: 'Owner',
    online: 'Online',
    offline: 'Offline',
    idle: 'Idle',
    dnd: 'Do Not Disturb',
    invisible: 'Invisible',
    unknown: 'unknown',
    language: 'Language',
    russian: 'Русский',
    english: 'English',
    error: 'Something went wrong',
    you: '(you)',
    closeMemberList: 'Close member list',
    total: '{count} total',
    create: 'Create',
    join: 'Join',
    add: 'Add',
    revoke: 'Revoke',
    description: 'Description',
    muteNotifications: 'Mute notifications',
    unmuteNotifications: 'Unmute notifications',
  },
  boot: { connecting: 'Connecting to TetherChat…' },
  auth: {
    loginTitle: 'Welcome back',
    loginSubtitle: 'We are happy to see you again.',
    loginIdentifier: 'Email or username',
    password: 'Password',
    forgotPassword: 'Forgot your password?',
    logIn: 'Log In',
    needAccount: 'Need an account?',
    register: 'Register',
    loginFailed: 'Could not sign in',
    totpTitle: 'Two-factor code',
    totpSubtitle: 'Enter the code from your authenticator app.',
    totpContinue: 'Continue',
    banned: 'This account is banned',
    passwordTab: 'Password',
    qrTab: 'QR code',
    qrTitle: 'Sign in with QR code',
    qrSubtitle: 'Scan the code in the TetherChat mobile app.',
    qrHint: 'On your phone: Settings → Sessions → Scan QR to sign in on desktop.',
    qrWaiting: 'Waiting for confirmation on your phone…',
    qrRefresh: 'Refresh code',
    qrRetry: 'Try again',
    qrExpired: 'This code expired. Tap “Refresh code”.',
    qrAlt: 'Sign-in QR code',
    qrStartFailed: 'Could not create the QR code',
    qrPollFailed: 'Could not check sign-in status',
    registerTitle: 'Create an account',
    alreadyRegistered: 'Already registered?',
    email: 'Email',
    username: 'Username',
    displayName: 'Display name',
    displayNameHint: 'Optional. Shown instead of your username.',
    continue: 'Continue',
    registerFailed: 'Could not create the account',
    registerVerifyHint: 'After sign-up we email a confirmation link. Password reset requires a verified address.',
    invalidEmail: 'Enter a valid email',
    usernameMin: 'At least {min} characters',
    usernamePattern: 'Lowercase letters, digits, dot, dash, underscore',
    passwordMin: 'At least {min} characters',
    resetTitle: 'Reset your password',
    resetSent: 'If that address is registered and verified, a reset link is on its way.',
    resetHint: 'We email a one-time link to your verified address. Confirm your email after sign-up first.',
    backToLogin: 'Back to login',
    sendReset: 'Send reset link',
    newPasswordTitle: 'Choose a new password',
    newPassword: 'New password',
    updatePassword: 'Update password',
    passwordUpdated: 'Password updated — sign in with your new password',
    missingToken: 'This link is missing its token.',
    verifyWorking: 'Verifying…',
    verifyDone: 'Email confirmed',
    verifyFailed: 'Verification failed',
    resendVerification: 'Resend confirmation email',
    verificationSent: 'Confirmation email sent',
    verifyEmailHint: 'Confirm your email from the message we sent so you can reset your password.',
    continueToApp: 'Continue to TetherChat',
  },
  invite: {
    checking: 'Checking invite…',
    invalid: 'Invalid invite',
    invalidHint: 'This invite has expired or never existed.',
    goToApp: 'Go to TetherChat',
    invited: '{name} invited you to join · {count} members',
    alreadyHaveAccount: 'Already have an account?',
    openServer: 'Open server',
    accept: 'Accept invite',
    signUpToJoin: 'Sign up to join',
  },
  crash: {
    title: 'Something broke',
    body: 'TetherChat hit an unexpected error. Reloading usually clears it.',
    reload: 'Reload',
    tryAgain: 'Try again',
  },
  update: {
    ready: 'A new version of TetherChat is ready.',
    reload: 'Reload',
    later: 'Later',
  },
  connection: {
    lost: 'Connection lost — retrying',
    reconnecting: 'Reconnecting to TetherChat…',
  },
  palette: {
    open: 'Quick switcher',
    placeholder: 'Jump to a channel, conversation or action…',
    empty: 'No matches',
    servers: 'Servers',
    channels: 'Channels',
    conversations: 'Conversations',
    friends: 'Friends',
    messages: 'Messages',
    actions: 'Actions',
    hintNavigate: 'navigate',
    hintSelect: 'open',
    hintClose: 'close',
  },
  nav: {
    servers: 'Servers',
    directMessages: 'Direct Messages',
    addServer: 'Add a Server',
    joinServer: 'Join a Server',
    joinInvite: 'Join with an Invite',
    userSettings: 'User settings',
    findConversation: 'Find or start a conversation',
    newConversation: 'New conversation',
    leaveGroup: 'Leave group',
    invitePeople: 'Invite People',
    serverSettings: 'Server Settings',
    createChannel: 'Create Channel',
    leaveServer: 'Leave Server',
    settings: 'Settings',
  },
  chat: {
    back: 'Back',
    notificationSettings: 'Notification settings',
    pinned: 'Pinned messages',
    hideMembers: 'Hide member list',
    showMembers: 'Show member list',
    search: 'Search',
    attach: 'Attach a file',
    emoji: 'Emoji',
    send: 'Send message',
    cancelReply: 'Cancel reply',
    replyTo: 'Replying to',
    messageChannel: 'Message #{name}',
    messageUser: 'Message {name}',
    messageAi: 'Ask the AI…',
    messageVpn: 'Message the bot: plans, subscription, trial…',
    messageMonitor: 'Server checks: status, disk, docker…',
    selectChannel: 'Select a channel',
    noPermission: 'You do not have permission to send messages here',
    friendsOnly: 'Direct messages are only available with friends',
    tooLong: 'Messages are limited to {max} characters',
    fileTooBig: '{name} is larger than {size}',
    uploadFailed: 'Could not upload {name}',
    removeFile: 'Remove {name}',
    jumpToPresent: 'Jump to present',
    historyFar: 'That message is further back in history',
    welcomeChannel: 'Welcome to #{name}!',
    startChannel: 'This is the start of the #{name} channel.',
    startDm: 'This is the beginning of your direct message history.',
    startAi: 'This is the built-in AI chat. Write like a normal conversation — replies are free.',
    startVpn: 'This is the VPN bot. Try **menu**, **plans**, **subscription**, or **trial**.',
    startMonitor: 'Server monitor bot. Try **status**, **disk**, **docker**, or **help**.',
    noChannel: 'No channel selected',
    pickChannel: 'Pick a channel from the sidebar to start reading.',
    unread: 'New',
    edited: '(edited)',
    sending: 'Sending…',
    failed: 'Failed to send',
    retrySend: 'Not delivered · tap to retry',
    openThread: 'Thread',
    thread: 'Thread',
    threadReply: 'Reply in thread…',
    threadReplies: '{count} in thread',
    seenBy: 'Seen by {count}',
    select: 'Select',
    selectedCount: '{count} selected',
    forwardedMany: 'Forwarded {count} messages',
    searchEverywhere: 'Search everywhere',
    searchAll: 'Everywhere',
    searchHere: 'Here',
    searchMatchFile: 'file',
    searchMatchLink: 'link',
    originalDeleted: 'Original message was deleted',
    openProfile: 'Open {name} profile',
    addReaction: 'Add reaction',
    reply: 'Reply',
    forward: 'Forward',
    forwarded: 'Message forwarded',
    forwardTo: 'Forward to…',
    forwardEmpty: 'Nothing to forward to',
    forwardedFrom: 'Forwarded from {name}',
    voice: 'Voice message',
    recording: '{clock}',
    voiceFailed: 'Could not send the voice message',
    micDenied: 'Microphone access denied',
    voicePlay: 'Play',
    voicePause: 'Pause',
    voiceDelete: 'Delete voice message',
    voiceSend: 'Send voice message',
    edit: 'Edit',
    pin: 'Pin',
    unpin: 'Unpin',
    delete: 'Delete',
    copyText: 'Copy text',
    editMessage: 'Edit message',
    pinMessage: 'Pin message',
    unpinMessage: 'Unpin message',
    deleteMessage: 'Delete message',
    moreReactions: 'More reactions',
    reactWith: 'React with {emoji}',
    reactedWith: '{count} reacted with {emoji}',
    copied: 'Message copied',
    reactions: 'Reactions',
    closePicker: 'Close emoji picker',
    searchTitleDm: 'Search {name}',
    searchTitleChannel: 'Search #{name}',
    searchMessages: 'Search messages…',
    searchHint: 'Type at least two characters to search.',
    searchEmpty: 'No messages matched.',
    pinsTitle: 'Pinned Messages',
    pinsDm: 'Pins are available in server channels.',
    pinsEmpty: 'Nothing pinned yet. Pin a message to keep it handy.',
    editorCancel: 'cancel',
    editorSave: 'save',
    editorHint: 'escape to {cancel} · enter to {save}',
    everyone: '@everyone',
    chatSettings: 'Chat settings',
    mediaTitle: 'Chat media',
    mediaEmpty: 'No photos or videos in this chat yet.',
    spoilerReveal: 'Click to reveal',
    nextMedia: 'Next',
    markSpoiler: 'Spoiler',
    pinChat: 'Pin',
    unpinChat: 'Unpin',
    deleteForMe: 'Delete for me',
    deleteForAll: 'Delete for everyone',
    deleteForMeConfirm: 'Delete chat "{name}" for you only? The other person will keep the history.',
    deleteForAllConfirm: 'Delete chat "{name}" for everyone? History will be removed for both.',
    deleteGroupForAllConfirm: 'Delete group "{name}" for all members?',
  },
  call: {
    start: 'Call',
    calling: 'Calling…',
    incoming: 'Incoming call',
    connecting: 'Connecting…',
    active: 'On call',
    ended: 'Call ended',
    accept: 'Accept',
    decline: 'Decline',
    hangUp: 'Hang up',
    mute: 'Mute microphone',
    unmute: 'Unmute microphone',
    enableSound: 'Enable sound',
    minimize: 'Minimize call',
    expand: 'Return to call',
    unknown: 'Contact',
  },
  typing: {
    one: 'is typing…',
    many: 'are typing…',
    and: '{a} and {b}',
    three: '{a}, {b} and {c}',
    people: '{count} people',
  },
  channel: {
    createIn: 'Create channel in {name}',
    markRead: 'Mark as read',
    copyLink: 'Copy link',
    editChannel: 'Edit channel',
    deleteChannel: 'Delete channel',
    linkCopied: 'Channel link copied',
    createTitle: 'Create a text channel',
    create: 'Create channel',
    name: 'Channel name',
    namePlaceholder: 'new-channel',
    topic: 'Topic',
    topicPlaceholder: 'What is this channel about?',
    nameRequired: 'Give the channel a name',
    created: '#{name} created',
    settingsName: 'Channel name',
    settingsTopic: 'Channel topic',
    settingsTopicHint: 'Let people know what this channel is for.',
    muteChannel: 'Mute channel',
    unmuteChannel: 'Unmute channel',
    deleteConfirm: 'Delete #{name} and all of its messages? This cannot be undone.',
    keepChannel: 'Keep channel',
    channelUpdated: 'Channel updated',
    channelDeleted: 'Channel deleted',
  },
  server: {
    createTitle: 'Create a server',
    name: 'Server name',
    namePlaceholder: 'Friendos',
    createHint: 'A #general and #off-topic channel are created for you.',
    joinTitle: 'Join a server',
    inviteLink: 'Invite link',
    membersCount: '{count} members',
    options: 'Server options',
    createDescription:
      'Your server is where you and your friends hang out. Make yours and start talking.',
    createReady: '{name} is ready',
    joinDescription: 'Enter an invite below to join an existing server.',
    joinInvalid: 'Paste an invite link or code',
    joined: 'Joined the server',
    nameMin: 'Use at least {min} characters',
    settingsTitle: '{name} settings',
    changeIcon: 'Change icon',
    iconHint: 'PNG, JPEG, GIF or WebP. Resized to 128px.',
    serverUpdated: 'Server updated',
    deleteServerTitle: 'Delete this server',
    deleteServerHint:
      'Every channel, message and member list is removed. Type {name} to confirm.',
    confirmServerName: 'Confirm server name',
    serverDeleted: 'Server deleted',
    overview: 'Overview',
    roles: 'Roles',
    bans: 'Bans',
    settingsSections: 'Server settings sections',
    newRole: 'New role',
    newRoleName: 'New role name',
    roleName: 'Role name',
    showSeparately: 'Show separately',
    showSeparatelyHint: 'Members with this role get their own member list section.',
    permissions: 'Permissions',
    saveRole: 'Save role',
    roleSaved: 'Role saved',
    roleDeleted: 'Role deleted',
    kickMember: 'Kick member',
    banMember: 'Ban member',
    memberRemoved: 'Member removed',
    memberBanned: 'Member banned',
    nobodyBanned: 'Nobody is banned.',
    banLifted: 'Ban lifted',
    deleteServerButton: 'Delete server',
    deleteRole: 'Delete role',
  },
  dm: {
    title: 'Direct Messages',
    findPeople: 'Find people',
    usernamePlaceholder: 'Type a username',
    newConversation: 'New conversation',
    emptyHint: 'No conversations yet. Start one with the + above.',
    conversation: 'Conversation',
    savedMessages: 'Saved Messages',
    savedHint: 'Saved messages',
    aiChat: 'AI chat',
    aiHint: 'Chat with the built-in assistant',
    vpnChat: 'Enigma VPN',
    vpnHint: 'VPN for Happ — plans and subscription',
    newConversationDescription: 'Friends only. Up to {max} people in a group.',
    createGroup: 'Create group',
    openConversation: 'Open conversation',
    nobodyMatched: 'Nobody matched that search.',
    searchHintShort: 'Type at least two characters to search.',
  },
  friends: {
    title: 'Friends',
    empty: 'Your friends list is empty.',
    sendRequest: 'Send friend request',
    sendRequestHint: 'Find someone by name and send a friend request.',
    requestSent: 'Friend request sent',
    becameFriends: 'You are now friends',
    incomingTitle: 'Friend requests',
    incoming: 'Requests',
    emptyIncoming: 'No pending requests.',
    accept: 'Accept',
    decline: 'Decline',
    add: 'Add friend',
  },
  report: {
    title: 'Report',
    comment: 'Message to admins',
    commentPlaceholder: 'What is wrong with this message?',
    submit: 'Send',
    sent: 'Report sent',
  },
  admin: {
    loginData: 'Admin login data',
    loginDataHint: 'Username and password for the admin app. They rotate every day at 00:00 Moscow time.',
    needsTwoFactor: 'Enable two-factor authentication first.',
    showCredentials: 'Show credentials',
    expiresAt: 'Valid until {time}',
  },
  settings: {
    title: 'User Settings',
    sections: 'Settings sections',
    profile: 'My Profile',
    account: 'Account',
    notifications: 'Notifications',
    appearance: 'Appearance',
    logOut: 'Log out',
    myAccount: 'My Account',
    editProfile: 'Edit Profile',
    accountSecurity: 'Account & Security',
    appSettings: 'App Settings',
    theme: 'Theme',
    themeHint:
      'TetherChat ships with a single dark theme. Colours come from CSS variables, so a light theme can be added without touching components.',
    dark: 'Dark',
    enterToSend: 'Enter sends the message',
    enterToSendMobile: 'On phones the send button is always shown and Enter inserts a newline.',
    enterToSendDesktop: 'Turn this off to require the send button and use Enter for newlines.',
    languageHint: 'Interface language. Russian is the default.',
    push: 'Push notifications',
    pushHint: 'Get notified about new messages even when TetherChat is closed.',
    pushBanner: 'Turn on notifications so you do not miss messages.',
    pushBannerAction: 'Enable',
    pushUnsupported: ' Not supported in this browser.',
    pushBlocked: 'Notifications are blocked in your browser settings',
    pushUnsupportedToast: 'This browser cannot receive push notifications',
    pushOn: 'Push notifications enabled',
    pushOff: 'Push notifications disabled',
    pushSiteBlocked:
      'Notifications are blocked for this site. Allow them in your browser settings, then try again.',
    perChannel: 'Per-channel settings',
    perChannelHint: 'Mute a single channel from its context menu in the channel list.',
    managedPerChannel: 'Managed per channel',
    email: 'Email',
    verified: 'Verified',
    unverified: 'Unverified',
    username: 'Username',
    usernameHint: 'Lowercase letters, digits, dot, dash and underscore.',
    usernameBad: 'That username is not allowed',
    usernameUpdated: 'Username updated',
    saveUsername: 'Save username',
    password: 'Password',
    passwordHint: 'We send a one-time link to {email}. Existing sessions sign out after a reset.',
    passwordUnverifiedHint: 'Verify your email first — password reset is unavailable until then.',
    sendReset: 'Send password reset link',
    resetSent: 'Password reset link sent to your email',
    displayName: 'Display name',
    displayHint: 'Shown instead of your username. Leave empty to use @username.',
    customStatus: 'Custom status',
    customStatusPlaceholder: 'What are you up to?',
    about: 'About me',
    aboutPlaceholder: 'A short description for your profile.',
    changeAvatar: 'Change avatar',
    remove: 'Remove',
    saveChanges: 'Save changes',
    profileUpdated: 'Profile updated',
    avatarUpdated: 'Avatar updated',
    downloadApp: 'Android app',
    downloadAppHint:
      'Install the native TetherChat Android app. If an update fails to install over the old version, uninstall the app and install the APK again.',
    downloadApk: 'Download APK',
    downloadAppInstalled: 'The app is already installed',
    blockedUsers: 'Blocked users',
    blockedUsersHint: 'Blocked people cannot open a 1:1 chat with you and will not notify you.',
    blockedEmpty: 'Nobody is blocked.',
    blockUser: 'Block user',
    unblockUser: 'Unblock',
    userBlocked: 'User blocked',
    userUnblocked: 'User unblocked',
    blockConfirm: 'Block {name}? Direct messages will be hidden and you will stop getting their notifications.',
    sessions: 'Sessions',
    sessionsHint: 'Devices where you are signed in. End a session if it is not yours.',
    thisDevice: 'This device',
    lastActive: 'active {time}',
    twoFactor: 'Two-factor authentication',
    twoFactorHint: 'Sign-in will also ask for a code from an authenticator app. Optional, but much safer.',
    twoFactorEnable: 'Enable two-factor',
    twoFactorConfirm: 'Confirm and enable',
    twoFactorDisable: 'Turn off',
    twoFactorCode: 'Authenticator code',
    twoFactorOn: 'Two-factor is on',
    twoFactorOff: 'Two-factor is off',
    twoFactorEnabled: 'Currently enabled.',
    endSession: 'End',
    endOtherSessions: 'Sign out other devices',
    sessionRevoked: 'Session ended',
    otherSessionsRevoked: 'Other sessions ended',
    plus: 'TetherChat Plus',
    aboutApp: 'About',
    aboutAppHint: 'Version, creator, release history',
    creator: 'Creator',
    versionHistory: 'Version history',
    versionHistoryHint: 'What changed in each update',
    currentVersion: 'Current version',
    currentBadge: 'current',
    versionLabel: 'Version {version}',
    whatsNew: "What's new",
    noReleaseNotes: 'No release notes for this version.',
    requiresReinstall: 'This update required reinstalling the app',
    androidVersion: 'Android {version}',
    androidVersionUnknown: 'Loading Android version…',
    install: 'Install',
    installHint: 'Download the native TetherChat app for Android, Windows, or Linux.',
    installUnavailable: 'Could not load download links. Try again later.',
    installAndroid: 'Android (APK)',
    installAndroidHint: 'Install on your phone. If an update fails, uninstall the old app and install the APK again.',
    installWindows: 'Windows',
    installWindowsHint: '.exe installer for Windows 10/11. A standalone app, not a browser tab.',
    installLinuxAppImage: 'Linux (AppImage)',
    installLinuxAppImageHint: 'Universal AppImage: chmod +x and run.',
    installLinuxDeb: 'Linux (deb)',
    installLinuxDebHint: 'Package for Ubuntu/Debian: sudo dpkg -i TetherChat.deb',
    downloadExe: 'Download .exe',
    downloadAppImage: 'Download AppImage',
    downloadDeb: 'Download .deb',
  },
  status: {
    online: 'Online',
    idle: 'Idle',
    dnd: 'Do Not Disturb',
    dndHint: 'No desktop notifications',
    invisible: 'Invisible',
    invisibleHint: 'You appear offline but stay connected',
    logOut: 'Log out',
  },
  inviteDialog: {
    title: 'Invite people to {name}',
    description: 'Share this link with anyone you want to join.',
    link: 'Invite link',
    copyFailed: 'Could not copy — select the link and copy manually',
    newLink: 'Generate a new link',
    generated: 'New invite generated',
  },
  profile: {
    sendDm: 'Message',
    addFriend: 'Add friend',
    requestSent: 'Request sent',
    memberSince: 'Member since',
    aboutMe: 'About me',
    roles: 'Roles',
  },
  time: {
    todayAt: '[Today at] h:mm A',
    yesterdayAt: '[Yesterday at] h:mm A',
    today: 'Today',
    yesterday: 'Yesterday',
  },
  plus: {
    title: 'TetherChat Plus',
    badge: 'Plus',
    feature: 'Feature',
    free: 'Free',
    paid: 'Plus',
    ctaHint: 'Ask the platform admin to enable Plus. Payments will come later.',
    activeHint: 'Your Plus subscription is active. Thank you for supporting TetherChat.',
    writeAdmin: 'To enable Plus, message the platform administrator.',
    openSettings: 'Open TetherChat Plus',
    upsellTitle: 'This is in Plus',
    upsellGeneric: 'This feature is available with TetherChat Plus.',
    upsellFiles: 'Files up to 30 MB are a Plus perk. The free limit is 10 MB.',
    upsellPins: 'Free accounts can pin 5 chats. Plus raises that to 10.',
    upsellBio: 'Plus expands About me to 500 characters with clickable links.',
    upsellTranscript: 'Voice transcripts sit on the audio bubble in Plus.',
    upsellColors: 'Custom banner and name colours are a Plus perk.',
    upsellLastSeen: 'Hiding exact last-seen time is a Plus perk.',
    upsellWallpaper: 'Custom chat wallpapers are a Plus perk.',
    upsellAccounts: 'Two accounts with quick switching are a Plus perk.',
    upsellSecret: 'Secret-chat screen protection is Plus. Screenshots cannot be blocked 100%.',
    perkFiles: '30 MB files and no upload rate limit',
    perkPins: '10 pinned chats',
    perkTranscript: 'Voice transcription',
    perkBadge: 'Plus badge and custom colours',
    screenshotHint:
      'Secret-chat protection hides the thread in recents and when the app is backgrounded. The OS cannot fully block screenshots — same as Telegram.',
    adminGrant: 'Grant Plus',
    grantSelf: 'Enable Plus for me',
    revokeSelf: 'Disable Plus for me',
    grantUsername: 'Username',
    grant: 'Grant',
    revoke: 'Revoke',
    granted: 'Plus enabled',
    revoked: 'Plus disabled',
    userNotFound: 'User not found',
    lastSeen: 'last seen {time}',
    hideLastSeen: 'Hide last seen',
    hideLastSeenHint: 'Others will only see online or offline.',
    bannerColor: 'Banner colour',
    accentColor: 'Name colour',
    colorsHint: 'Custom profile colours require Plus.',
    chatHidden: 'Chat hidden',
    peerProtect: 'Peer has screen protection',
    addAccount: 'Add account',
    switchAccount: 'Switch account',
    accountsFull: 'Two accounts are already saved',
    transcribe: 'Transcribe',
    transcribing: 'Transcribing…',
    wallpaper: 'Chat wallpaper',
    changeWallpaper: 'Change wallpaper',
    removeWallpaper: 'Remove wallpaper',
    row: {
      files: 'File size',
      pins: 'Pinned DMs and groups',
      bio: 'About me length',
      accounts: 'Accounts',
      transcript: 'Voice transcript',
      upload: 'Upload rate limit',
      lastSeen: 'Last seen',
      secret: 'Secret chat',
      colors: 'Profile colours',
      badge: 'Plus badge',
      wallpaper: 'Chat wallpaper',
      icons: 'Android icon',
    },
  },
} as const;
